import { FC, useMemo } from 'react';
import { Box, BoxProps, Image as ChakraImage } from '@chakra-ui/react';

import PlaceholderLoader from 'components/PlaceholderLoader';

import locales from './locales';

// Returns the cached logo if it exists
const getCachedLogo = (logoUrl: string) => {
  const image = new Image();
  image.src = logoUrl;

  return image.complete ? image : null;
};

interface CompanyLogoProps extends BoxProps {
  logoUrl: string;
  size?: 'sm' | 'md' | 'lg';
}

const CompanyLogo: FC<CompanyLogoProps> = ({ logoUrl, size, ...props }) => {
  const cachedLogo = getCachedLogo(logoUrl);

  const { height, maxWidth } = useMemo(() => {
    switch (size) {
      case 'md':
        return { height: 56, maxWidth: 104 };
      case 'lg':
        return { height: 80, maxWidth: 160 };
      case 'sm':
      default:
        return { height: 40, maxWidth: 80 };
    }
  }, [size]);

  return (
    <Box {...props}>
      <ChakraImage
        alt={locales.altText}
        fallback={<PlaceholderLoader height={height} width={maxWidth} />}
        height={height}
        // We don't want the loader if the image is already cached
        ignoreFallback={Boolean(cachedLogo)}
        maxWidth={maxWidth}
        objectFit="contain"
        src={logoUrl}
      />
    </Box>
  );
};

export default CompanyLogo;
